import { Done } from "@mui/icons-material";
import { Box, Checkbox } from "@mui/joy";
import { CellContext, HeaderContext } from "@tanstack/react-table";
import { useCallback } from "react";

import { useRoutesUiStore } from "@/components/RoutesProvider";

import { Route } from "../../core/types";
import { useModal } from "../modals/useModal";

export const SelectionHeaderCell = (props: HeaderContext<Route, unknown>) => {
  const { routeFormIsDirty } = useRoutesUiStore();
  const { display: displayModal } = useModal();

  const handler = props.table.getToggleAllRowsSelectedHandler();

  const onChange = useCallback(
    (event: unknown) => {
      if (!routeFormIsDirty) {
        handler(event);
      } else {
        displayModal("UNSAVED_ROUTE_CHANGES_PROMPT");
      }
    },
    [handler, displayModal, routeFormIsDirty],
  );

  return (
    <Checkbox
      checked={props.table.getIsAllRowsSelected()}
      indeterminate={props.table.getIsSomeRowsSelected()}
      onChange={onChange}
    />
  );
};

export const SelectionCell = (
  props: CellContext<Route, unknown> & {
    onCheckboxChange?: (event: unknown) => void;
  },
) => {
  return (
    <Box
      sx={{
        marginX: -1,
        marginY: -2,
        width: 34,
        height: 34,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Checkbox
        overlay
        checked={props.row.getIsSelected()}
        onChange={props.onCheckboxChange}
        onClick={(e) => e.stopPropagation()}
        id={`checkbox-${props.row.id}`}
        uncheckedIcon={<Done />}
        slotProps={{
          root: ({ checked, focusVisible }) => ({
            sx: !checked
              ? {
                  "& svg": { opacity: focusVisible ? 1 : 0 },
                  "&:hover svg": {
                    opacity: 1,
                  },
                }
              : undefined,
          }),
        }}
      />
    </Box>
  );
};
